(() => {
  'use strict';
  const base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  const validId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0;
  const validPrice = value => value !== null && value !== undefined && value !== '' && Number.isSafeInteger(Number(value)) && Number(value) >= 0;
  const isGift = item => item.properties && item.properties._gutsupp_gift_source === 'gutsupp-subscription-gifts';
  const variantOf = item => String(item.variant_id || item.id || '');
  const planOf = item => String(item.selling_plan_allocation && (item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || item.selling_plan_allocation.selling_plan_id) || item.selling_plan || '');

  function initialize(page) {
    if (page.dataset.stackedReady === 'true') return;
    page.dataset.stackedReady = 'true';
    const root = page.closest('.shopify-section') || page.parentElement;
    const cards = Array.from(page.querySelectorAll('.buy-area-gutsupp__card'));
    const mainButton = page.querySelector('#add-to-cart');
    const onceButton = page.querySelector('[data-otp-copy]');
    const errorElement = page.querySelector('[data-buy-error]');
    const labelsElement = page.querySelector('[data-stacked-labels]');
    const manager = window.GutSuppCartGifts;
    let labels = {};
    let selected;
    let busy = false;
    let redirecting = false;
    let fatal = false;
    let pendingPurchase = null;
    let busyButton = null;
    try { labels = JSON.parse(labelsElement && labelsElement.textContent || '{}'); } catch (_) { fatal = true; }

    function label(key, values = {}) {
      return Object.entries(values).reduce((copy, [name, value]) => copy.split(`[${name}]`).join(String(value)), String(labels[key] || key));
    }
    function money(value) {
      if (!validPrice(value)) throw new Error(label('price_error'));
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: page.dataset.currency || 'GBP' }).format(Number(value) / 100);
    }
    function option(card, oneTime = false) {
      if (!card) return null;
      return {
        variant: card.dataset.variantId,
        plan: oneTime ? null : card.dataset.planId,
        price: oneTime ? card.dataset.oneTimeCents : card.dataset.primaryCents,
        available: card.dataset[oneTime ? 'oneTimeAvailable' : 'subAvailable'] === 'true',
        giftCount: oneTime ? 0 : Number(card.dataset.giftCount || 0),
        days: Number(card.dataset.singlePurchaseDays || 0)
      };
    }
    function canBuy(chosen) {
      return !!chosen && chosen.available && validId(chosen.variant) && validPrice(chosen.price) && (chosen.plan === null || validId(chosen.plan));
    }
    function showError(error) {
      if (!errorElement) return;
      errorElement.textContent = error ? error.message || label('cart_error') : '';
      errorElement.hidden = !error;
    }
    function status(key) {
      const text = label(key);
      const loading = busyButton && busyButton.querySelector('[data-buy-loading-label]');
      if (loading) loading.textContent = text;
    }
    function refreshControls() {
      if (mainButton) { mainButton.disabled = busy || fatal || !canBuy(option(selected)); mainButton.setAttribute('aria-busy', String(busy && busyButton === mainButton)); }
      if (onceButton) { onceButton.disabled = busy || fatal || !canBuy(option(selected, true)); onceButton.setAttribute('aria-busy', String(busy && busyButton === onceButton)); }
      page.setAttribute('aria-busy', String(busy));
      cards.forEach(card => {
        const unavailable = !canBuy(option(card)) && !canBuy(option(card, true));
        card.setAttribute('aria-disabled', String(busy || unavailable));
        card.tabIndex = busy || unavailable ? -1 : 0;
      });
    }
    function setActive(card) {
      if (busy || !card || !canBuy(option(card)) && !canBuy(option(card, true))) return;
      selected = card;
      cards.forEach(candidate => {
        const active = candidate === card;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-checked', String(active));
        const giftPanel = candidate.querySelector('[data-stacked-gift-panel]');
        if (giftPanel) giftPanel.hidden = !active;
      });
      const planInput = root.querySelector('.product-template__selling-plan');
      const variantInput = root.querySelector('.product-template__variant');
      if (planInput) planInput.value = card.dataset.planId || '';
      if (variantInput) variantInput.value = card.dataset.variantId || '';
      const primary = page.querySelector('[data-buy-primary-price]');
      const compare = page.querySelector('[data-buy-compare-price]');
      if (primary) primary.textContent = validPrice(card.dataset.primaryCents) ? money(card.dataset.primaryCents) : '';
      if (compare) { compare.textContent = validPrice(card.dataset.oneTimeCents) ? money(card.dataset.oneTimeCents) : ''; compare.classList.toggle('is-hidden', !compare.textContent); }
      const onceCopy = onceButton && onceButton.querySelector('[data-buy-otp-label]');
      if (onceCopy) onceCopy.textContent = label('buy_once', { months: Number(card.dataset.singlePurchaseDays) / 30, price: validPrice(card.dataset.oneTimeCents) ? money(card.dataset.oneTimeCents) : '' });
      const count = Number(card.dataset.giftCount || 0);
      const giftCopy = page.querySelector('[data-stacked-cta-gifts]');
      if (giftCopy) giftCopy.textContent = count ? label(count === 1 ? 'cta_gift_one' : 'cta_gift_many', { count }) : '';
      showError(null);
      page.dispatchEvent(new CustomEvent('gutsupp:plan-change', { bubbles: true }));
      if (window.GutSuppBundleGallery) window.GutSuppBundleGallery.swap(root, window.GutSuppBundleGallery.urlFromElement(card));
      refreshControls();
    }
    async function request(path, body) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(base + path, {
          method: body === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'application/json', ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) },
          ...(body === undefined ? {} : { body: JSON.stringify(body) }), signal: controller.signal
        });
        let data;
        try { data = await response.json(); } catch (_) { const error = new Error(label('cart_error')); error.retryable = true; throw error; }
        if (!response.ok) {
          const error = new Error(data && (data.description || data.message) || label('cart_error'));
          error.retryable = response.status === 408 || response.status === 429 || response.status >= 500;
          throw error;
        }
        return data;
      } catch (error) {
        if (error.name === 'AbortError') { const failure = new Error(label('timeout')); failure.retryable = true; throw failure; }
        throw error;
      } finally { window.clearTimeout(timeout); }
    }
    const pause = attempt => new Promise(resolve => window.setTimeout(resolve, Math.min(200 * (attempt + 1), 500)));
    async function readCart() {
      for (let attempt = 0; attempt < 3; attempt += 1) {
        try { return await request('cart.js'); }
        catch (error) { if (error.retryable === false || attempt === 2) throw error; await pause(attempt); }
      }
    }
    function purchaseQuantity(cart, chosen) {
      if (!cart || !Array.isArray(cart.items)) throw new Error(label('cart_error'));
      return cart.items.filter(item => !isGift(item) && variantOf(item) === String(chosen.variant) && planOf(item) === String(chosen.plan || ''))
        .reduce((quantity, item) => quantity + Number(item.quantity || 0), 0);
    }
    async function ensurePurchase(chosen) {
      const key = `${chosen.variant}:${chosen.plan || ''}`;
      let cart = await readCart();
      if (!pendingPurchase || pendingPurchase.key !== key) pendingPurchase = { key, quantity: purchaseQuantity(cart, chosen) + 1 };
      let failure;
      for (let attempt = 0; attempt < 3; attempt += 1) {
        if (purchaseQuantity(cart, chosen) >= pendingPurchase.quantity) return cart;
        try {
          await request('cart/add.js', { items: [{ id: Number(chosen.variant), quantity: pendingPurchase.quantity - purchaseQuantity(cart, chosen), ...(chosen.plan ? { selling_plan: Number(chosen.plan) } : {}) }] });
        } catch (error) {
          failure = error;
          if (error.retryable === false) { pendingPurchase = null; throw error; }
        }
        cart = await readCart();
        if (purchaseQuantity(cart, chosen) >= pendingPurchase.quantity) return cart;
        if (attempt < 2) await pause(attempt);
      }
      throw failure || new Error(label('cart_error'));
    }
    function verifyCart(cart) {
      if (!cart || !Array.isArray(cart.items) || !validPrice(cart.total_price)) throw new Error(label('cart_error'));
      const config = manager.config;
      if (config.enabled !== true) throw new Error(label('offer_unavailable'));
      const parent = (config.tiers || []).filter(tier => cart.items.some(item => !isGift(item) && Number(item.quantity) > 0 && variantOf(item) === String(tier.variant) && planOf(item) === String(tier.plan)))
        .sort((left, right) => Number(right.days) - Number(left.days))[0];
      const wanted = parent ? (Number(parent.days) >= 180 ? [config.mug, config.whisk] : [config.mug]).map(String) : [];
      const gifts = cart.items.filter(isGift);
      if (gifts.length !== wanted.length || wanted.some(id => gifts.filter(item => variantOf(item) === id).length !== 1) || gifts.some(item => Number(item.quantity) !== 1 || !validPrice(item.final_line_price) || Number(item.final_line_price) !== 0)) throw new Error(label('gift_error'));
      return cart;
    }
    async function add(oneTime) {
      if (busy || fatal) return;
      const chosen = option(selected, oneTime);
      if (!canBuy(chosen)) return showError(new Error(label('option_unavailable')));
      if (chosen.giftCount && !(manager.config.tiers || []).some(tier => String(tier.variant) === String(chosen.variant) && (chosen.plan ? String(tier.plan) === String(chosen.plan) : tier.allowOneTime === true))) return showError(new Error(label('loading_error')));
      busy = true;
      redirecting = false;
      busyButton = oneTime ? onceButton : mainButton;
      showError(null);
      status('preparing');
      refreshControls();
      page.dispatchEvent(new CustomEvent('gutsupp:purchase-state', { bubbles: true, detail: { busy: true } }));
      try {
        await manager.run(async context => {
          const purchaseCart = await ensurePurchase(chosen);
          status(chosen.giftCount ? 'adding_gifts' : 'confirming');
          const cart = verifyCart(await context.reconcile({ sections: false, initialCart: purchaseCart }));
          const intendedKey = `${chosen.variant}:${chosen.plan || ''}`;
          if (!pendingPurchase || pendingPurchase.key !== intendedKey || purchaseQuantity(cart, chosen) < pendingPurchase.quantity) throw new Error(label('cart_error'));
          status('opening_checkout');
          redirecting = true;
          window.location.assign(base + 'checkout');
        });
      } catch (error) {
        redirecting = false;
        showError(error);
        status('check_order');
      } finally {
        busy = redirecting;
        refreshControls();
        page.dispatchEvent(new CustomEvent('gutsupp:purchase-state', { bubbles: true, detail: { busy } }));
      }
    }
    const delivery = page.querySelector('[data-delivery-date]');
    if (delivery) {
      const now = new Date();
      const cutOff = new Date(now); cutOff.setHours(14, 0, 0, 0);
      let remaining = now >= cutOff ? 2 : 1;
      const date = new Date(now);
      while (remaining > 0) { date.setDate(date.getDate() + 1); if (date.getDay() !== 0 && date.getDay() !== 6) remaining -= 1; }
      delivery.textContent = date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short' });
    }
    if (!manager || typeof manager.run !== 'function' || !manager.config || !document.querySelector('.cart-aside') || !cards.length) fatal = true;
    cards.forEach(card => {
      card.addEventListener('click', () => setActive(card));
      card.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); setActive(card); }
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || busy) return;
        event.preventDefault();
        const available = cards.filter(candidate => canBuy(option(candidate)) || canBuy(option(candidate, true)));
        const direction = ['ArrowUp', 'ArrowLeft'].includes(event.key) ? -1 : 1;
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? available.length - 1 : (available.indexOf(card) + direction + available.length) % available.length;
        if (available[index]) { setActive(available[index]); available[index].focus(); }
      });
    });
    page.addEventListener('click', event => {
      const target = event.target instanceof Element && event.target.closest('#add-to-cart, [data-otp-copy]');
      if (!target || !page.contains(target)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (!target.disabled) add(target.hasAttribute('data-otp-copy'));
    }, true);
    const initial = cards.find(card => Number(card.dataset.singlePurchaseDays) === 90 && canBuy(option(card))) || cards.find(card => canBuy(option(card))) || cards.find(card => canBuy(option(card, true)));
    if (initial) setActive(initial);
    if (fatal) showError(new Error(label('loading_error')));
    refreshControls();
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      redirecting = false; busy = false; pendingPurchase = null; busyButton = null;
      showError(null); refreshControls();
      page.dispatchEvent(new CustomEvent('gutsupp:purchase-state', { bubbles: true, detail: { busy: false } }));
    });
    document.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target instanceof Element && event.target.closest('a[href]');
      if (!link || link.target === '_blank' || !selected || !mainButton) return;
      let url;
      try { url = new URL(link.href, window.location.href); } catch (_) { return; }
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !['#buy-area', '#buy'].includes(url.hash)) return;
      event.preventDefault(); event.stopPropagation();
      const topInset = window.innerWidth >= 1024 ? 96 : 80;
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const start = selected.getBoundingClientRect().top;
      const end = mainButton.getBoundingClientRect().bottom;
      const targetTop = topInset + Math.max(0, (viewportHeight - topInset - 24 - (end - start)) / 2);
      window.scrollTo({ top: Math.max(0, window.scrollY + start - targetTop), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, true);
  }
  function initializeAll() { document.querySelectorAll('[data-stacked-gifts]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
